const moduleRoute = {
  path: '/convenios',
  component: () => import('@/views/Home.vue'),
  meta: { requiresAuth: true },
  children: [
    {
      // MU-20 PR 8c: criação e edição do convênio agora em React. Com :id
      // (clinic_health_plan_id) a ilha redireciona para o detalhe por
      // identidade; sem :id, é a criação.
      path: ':id?',
      component: () => import('@/views/Configs/ConvenioVinculoReact.vue')
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
